export function isInternalLink(target: string): boolean {
  return target.startsWith('/');
}

export function getRequestPath(
  definition: string,
  pathParam: Record<string, unknown>
): string {
  const match = definition.match(/:[^\/]+/g);
  const result = match
    ? match.reduce((prev, cur) => {
        const key = cur.replace(':', '');

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const value = (pathParam as any)[key];
        if (value == null) {
          return prev;
        }

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        delete (pathParam as any)[key];
        return prev.replace(cur, value);
      }, definition)
    : definition;

  const query = Object.keys(pathParam).reduce((prev, cur) => {
    const prefix = prev === '' ? '?' : '&';

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return `${prev}${prefix}${cur}=${(pathParam as any)[cur]}`;
  }, '');

  return result + query;
}

/**
 * メールアドレスが不正か検証する。 email のドメイン部分がマルチバイトの場合は既にPunycode化されていることを想定している。
 * @param {string} email メールアドレス
 * @return {boolean} メールアドレスが不正な場合 true
 */
export function validateEmailAddress(email: string): boolean {
  const domain = email.split('@')[1];

  // 現在マルチバイトのドメインでユーザーを登録することはできません。
  // マルチバイトのドメインが入力された場合、ドメインが Punycode に変換されています。
  // Punycodeの先頭は必ず「xn--」となります。
  // ちなみに「xn--」は国際化ドメインの予約語となり、先頭が「xn--」の英語表記ドメインは取得することが出来ません。
  if (domain != undefined) {
    const prefixIDNDomain = 'xn--';
    if (domain.startsWith(prefixIDNDomain)) {
      return true;
    }
  }

  return false;
}
